import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
//import ReactDOM from 'react-dom';
import './styles/index.css';
import { ptr } from './store/pointers'

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import history from './store/history';
import version from "./buildversion.json";
import App from './App';
import { setStateInstalled, setStateLoaded, setStateStandalone } from './store/store';

console.log(`${process.env.REACT_APP_NAME} ${process.env.REACT_APP_VERSION}`);

let installPrompt = null;
const installButton = document.querySelector("#install");

window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  installPrompt = event;
  console.log('beforeinstallprompt', installPrompt);
  setStateInstalled(false);
  //installButton.removeAttribute("hidden");
});

// do action when finished install
window.addEventListener('appinstalled', (event) => {
  console.log("appinstalled", event);
  setStateInstalled(true);
  //saveAppState();
  //getDataAPI('install');  // log the install
});

// do action when uninstall
window.addEventListener('appuninstalled', (event) => {
  console.log("appuninstalled", event);
  //clearData();
  //getDataAPI('uninstall');  // log the uninstall
});

const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
console.log('Chrome: ', raw);
console.log('Version', version);

const location = window.location.href;
const lh = location.includes('localhost');
console.log('localhost', location, lh);

if (!('serviceWorker' in navigator)) {
  console.log('serviceWorker NOT supported!');
} else {
  console.log('serviceWorker supported!');
}

if (!('PushManager' in window)) {
  console.log('PushManager NOT supported on this browser!');
} else {
  console.log('PushManager supported!');
}

if (!lh) {
  console.log('before register');
  serviceWorkerRegistration.register();
  console.log('after register');
} else {
  console.log('not registering ServiceWorker');
}

const standalone = (window.matchMedia('(display-mode: standalone)').matches);
setStateLoaded(false);
setStateStandalone(standalone);
//saveAppState();
console.log('standalone', standalone);

global.ptr = new ptr();

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <Router history={history} >
    <App />
  </Router>
);
